import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import EditForm from "../common/form.vue";
import { ref, onBeforeMount, inject, computed } from "vue";
import { useRoute } from "vue-router";
import { get, set } from "@vueuse/core";
import { StaffServices } from "@/clinic/services";
import { ApiStaffDetailReq, ApiStaffDetailRes, IStaff } from "@/clinic/typings";
import { AxiosResponse } from "axios";
import rules from "../common/rules";
import Trash from "@/clinic/components/trash.vue";
import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";
import { useToast } from "primevue/usetoast";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const toast = useToast();
const clinicId = ref(0);
const staff = ref<ApiStaffDetailRes>();

const idUrl = computed((): number => {
  const { params } = route;
  const { id } = params;
  return id as unknown as number;
});

const onTrash = async () => {
  await StaffServices.trashStaff(
    get(idUrl),
    {
      clinic_id: get(await get(clinicId)),
    },
    () => notifySuccessMsg(toast, "成功"),
    () => notityErrorMsg(toast, "エラー")
  );
};

onBeforeMount(async () => {
  await set(clinicId, await inject("clinicId"));
  const { data } = (await StaffServices.getStaff(get(idUrl), {
    clinic_id: get(await get(clinicId)),
  } as unknown as ApiStaffDetailReq)) as unknown as AxiosResponse<ApiStaffDetailRes>;
  set(staff, get(data));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Trash, {
      id: _unref(get)(_unref(idUrl)),
      onTrash: onTrash
    }, null, 8, ["id"]),
    (staff.value)
      ? (_openBlock(), _createBlock(EditForm, {
          key: 0,
          clinicId: _unref(get)(clinicId.value),
          model: staff.value,
          rules: _unref(rules),
          hasEdit: ""
        }, null, 8, ["clinicId", "model", "rules"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})